
                (function ($) {
                    if (!window.jQuery) {
                        var script = document.createElement('script');
                        script.type = "text/javascript";
                        script.src = "https://code.jquery.com/jquery-3.5.0.min.js";
                        document.getElementsByTagName('head')[0].appendChild(script);
                    }
                
                    var mapScript = document.createElement('script');
                    mapScript.type = "text/javascript";
                    mapScript.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBY1xlGe6jLbugOJegCsUGnzlufYWa5CRw&libraries=places";
                    document.getElementsByTagName('head')[0].appendChild(mapScript);

                    var clusterScript = document.createElement('script');
                    clusterScript.type = "text/javascript";
                    clusterScript.src = "https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js";
                    document.getElementsByTagName('head')[0].appendChild(clusterScript);

                    var fontawesomeScript = document.createElement('script');
                    fontawesomeScript.type = "text/javascript";
                    fontawesomeScript.src = "https://use.fontawesome.com/718f366291.js";
                    document.getElementsByTagName('head')[0].appendChild(fontawesomeScript);

                    var redboxScript = document.createElement('script');
                    redboxScript.type = "text/javascript";
                    redboxScript.src = "https://shopapp.redboxsa.com/js/redbox_shipping.js?v=1";
                    document.getElementsByTagName('head')[0].appendChild(redboxScript);

                    var redboxSheet = document.createElement('link');
                    redboxSheet.rel = "stylesheet"
                    redboxSheet.type = "text/css";
                    redboxSheet.href = "https://shopapp.redboxsa.com/css/redbox_shipping.css?v=1";
                    document.getElementsByTagName('head')[0].appendChild(redboxSheet);
                })(window.jQuery);
            